var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 31,
    viewBox: "0 0 31 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_216_408)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5 2.71011e-06C6.95302 1.2157e-06 -1.2157e-06 6.95302 -2.71011e-06 15.5C-4.20451e-06 24.047 6.95302 31 15.5 31C24.047 31 31 24.047 31 15.5C31 6.95303 24.047 4.20451e-06 15.5 2.71011e-06ZM20.2882 16.4132L13.8299 22.8715C13.578 23.1234 13.2473 23.25 12.9166 23.25C12.586 23.25 12.2553 23.1234 12.0034 22.8715C11.4984 22.3665 11.4984 21.5501 12.0034 21.0451L17.5486 15.5L12.0035 9.95488C11.4985 9.44985 11.4985 8.6335 12.0035 8.12848C12.5085 7.62346 13.3249 7.62346 13.8299 8.12848L20.2882 14.5868C20.7932 15.0919 20.7932 15.9081 20.2882 16.4132Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_216_408"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31,
    height: 31,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.afd550f674bad85361d70d8b494b46cf.svg";
export { ForwardRef as ReactComponent };